












































import { Component, Vue, Inject } from 'vue-property-decorator'
import { RealworksCredentials } from '@/api/model/credentials'
import { CredentialsType } from '@/api/types'
import { v4 as uuid } from 'uuid'
import { RealworksCredentialsAPI } from '@/api/backend-client'

@Component
export default class CompanySettingsRealworksCredentialsCreate extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    credentials: RealworksCredentials = null
    saving: boolean = false

    get realworksCredentials(): RealworksCredentials[] {
        return this.$currentCompany.getCredentialsWithType(CredentialsType.REALWORKS) as RealworksCredentials[]
    }

    async created(): Promise<void> {
        this.credentials = RealworksCredentials.fromData({
            company: this.$currentCompany,
            id: uuid(),
            apiKey: null,
            description: null,
            enabled: true,
            createdAt: new Date(),
            createdBy: this.$currentUser,
            updatedAt: new Date(),
            updatedBy: this.$currentUser,
            credentialsType: CredentialsType.REALWORKS,
        })
    }

    async save(): Promise<void> {
        this.saving = true
        this.credentials = await RealworksCredentialsAPI.create(this.credentials)
        await this.reloadCompany()
        this.saving = false
        await this.$router.push({ name: 'company_settings_realworks_credentials_list' })
    }

    async cancel(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_realworks_credentials_list',
        })
    }

    get canCreateRealworksCredentials(): boolean {
        const counts = {
            agenda : 0,
            objecten : 0,
            facturen : 0,
            relaties : 0,
            taken : 0,
        }

        this.realworksCredentials.forEach(item => {
            counts.agenda += item.canRequestAgenda ? 1 : 0
            counts.objecten += item.canRequestObjecten ? 1 : 0
            counts.facturen += item.canRequestFacturen ? 1 : 0
            counts.relaties += item.canRequestRelaties ? 1 : 0
            counts.taken += item.canRequestTaken ? 1 : 0
        })

        counts.agenda += this.credentials.canRequestAgenda ? 1 : 0
        counts.objecten += this.credentials.canRequestObjecten ? 1 : 0
        counts.facturen += this.credentials.canRequestFacturen ? 1 : 0
        counts.relaties += this.credentials.canRequestRelaties ? 1 : 0
        counts.taken += this.credentials.canRequestTaken ? 1 : 0

        for (const index in counts) {
            if (counts[index] > this.$currentCompany.amountOfBranches) {
                return false
            }
        }

        return true
    }
}
